export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_SPECIAL_CHARACTERS = '!@#$&()\\-`.+,/"';

export const PASSWORD_VALIDATION_REGEX = new RegExp(
  `^(?=.*[A-Za-z])(?=.*\\d)(?=.*[${PASSWORD_SPECIAL_CHARACTERS}])[A-Za-z\\d${PASSWORD_SPECIAL_CHARACTERS}]{${PASSWORD_MIN_LENGTH},}$`
);
